<template>
  <div>
    <page-heading page-title="Login"
                  v-bind:links="[
                      {target: '#help-modal', text: 'Help'}
                    ]">
    </page-heading>
    <div id="content" class="container">
      <div class="row">
        <div class="col">
          <page-alert v-bind:class="{'invisible': isBridgeConnected}">
            <div slot="message">Error connecting to the Real-time Interface</div>
          </page-alert>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-9">
          <form id="login-form" class="form-group" novalidate autocomplete="off" @submit.prevent="login()">
            <div class="row">
              <div class="col-auto">
                <label for="observing-token-input" class="col-form-label">Observing token:</label>
              </div>
              <div class="col">
                <input id="observing-token-input" type="text" class="form-control" v-model="token" required>
                <div class="invalid-feedback">{{ loginFeedback }}</div>
              </div>
              <div class="col-auto">
                <button id="begin-session-button" class="btn btn-primary" type="submit" :disabled="!isBridgeConnected">
                  Begin session
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <help-modal>
        <div slot="help-text">
          <p>
            There may only be one active Real-time Interface (RTI) session at a time for every telescope. Multiple
            sessions may be active at a time, as long as they are using different telescopes.
          </p>
          <p>
            This does not apply to users passively using the RTI up to 5 minutes before or 15 minutes after their
            sessions.
          </p>
        </div>
      </help-modal>
    </div>
  </div>
</template>

<script>
  import 'rti.css';
  import { bridgeConnection, initValidation } from '../js/common';
  import PageAlert from 'pageAlert.vue';
  import PageHeading from 'pageHeading.vue';
  import HelpModal from 'helpModal.vue';

  export default {
    name: 'app',
    components: {
      HelpModal,
      PageAlert,
      PageHeading
    },
    data: function() {
      return {
        loginFeedback: '',
        loginRequest: '',
        loginPath: '/login',
        loginUrl: '',
        token: '',
        isBridgeConnected: true,
        timer: null
      };
    },
    mounted: function() {
      this.loginUrl = bridgeConnection.bridgeUrl + this.loginPath;
      initValidation('login-form');

      this.timer = setInterval(
        this.tick, 4000
      );
    },
    beforeDestroy: function() {
      clearInterval(this.timer);
    },
    methods: {
      login: function() {
        if (this.token === '') {
          this.loginFeedback = 'Enter a token';

          return;
        }

        this.loginFeedback = '';

        let xhr = new XMLHttpRequest();
        xhr.open('POST', this.loginUrl, true);
        xhr.setRequestHeader('Content-type', 'application/json');

        xhr.send(JSON.stringify({'token': this.token}));

        xhr.onload = () => {
          let jsonResponse = JSON.parse(xhr.responseText);
          let tokenStatus = jsonResponse.tokenStatus;
          let rtiSession = jsonResponse.rtiSession;

          let tokenInput = document.getElementById('observing-token-input');

          if (tokenStatus === 'INVALID') {
            this.loginFeedback = 'Invalid token';
            tokenInput.setCustomValidity('INVALID');
          } else if (tokenStatus === 'EXPIRED') {
            this.loginFeedback = 'Session has ended';
            tokenInput.setCustomValidity('EXPIRED');
          } else if (tokenStatus === 'UNEXPIRED') {
            this.loginFeedback = 'Session has not begun yet';
            tokenInput.setCustomValidity('UNEXPIRED');
          } else if (tokenStatus === 'ACTIVE' || tokenStatus === 'INACTIVE') {
            this.loadRtiPage(rtiSession);
          } else {
            this.loginFeedback = 'Unknown token error';
            tokenInput.setCustomValidity('UNKNOWN');
          }
        };

        xhr.onerror = function() {
          console.error('There was an unknown error while trying to login using the token');
        };
      },
      loadRtiPage: function(rtiSession) {
        let session = {};
        session.userId = rtiSession.userId;
        session.sessionStart = rtiSession.sessionStart;
        session.sessionEnd = rtiSession.sessionEnd;
        session.activeSessionStart = rtiSession.activeSessionStart;
        session.activeSessionEnd = rtiSession.activeSessionEnd;
        session.telescopeInfo = JSON.stringify(rtiSession.telescopeInfo);
        session.token = this.token;

        this.$router.push(
          {
            name: 'rti',
            params: {session: session}
          });
      },
      tick: function() {
        bridgeConnection.isConnected((results) => {
          this.isBridgeConnected = results;
        });
      }
    }
  };
</script>
